<template>
    <edit></edit>
</template>

<script>
    import edit from './offline_activity_edit.vue'

    export default {
        name: 'offline_activity_add',

        components: {
            edit
        }
    }
</script>